import React, { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  InputAdornment,
  IconButton,
  Checkbox,
  Link,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid
} from '@mui/material';
import { AccountCircle, Lock, Visibility, VisibilityOff } from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import fondo from './fondo_portal_facturas.png';
import cab from './logovv_tabla_ingreso.png';
import cabtop from './logo_portal_facturas.png';

// Bot�n con bordes ovalados
const RoundedButton = styled(Button)({
  borderRadius: '25px',
  backgroundColor: '#00a63f',
  color: '#fff',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#008c34'
  },
  padding: '10px 0',
});

// TextField con bordes ovalados y labels negras
const RoundedTextField = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '25px',
    paddingRight: '10px',
  },
  '& .MuiInputLabel-root': {
    color: '#000',
    fontWeight: 'bold',
  },
  '& .Mui-focused .MuiInputLabel-root': {
    color: '#000',
  },
});

// Checkbox circular verde
const GreenCheckbox = styled(Checkbox)({
  '& .MuiSvgIcon-root': {
    borderRadius: '50%',
  },
  '&.Mui-checked': {
    color: '#00a63f'
  }
});

export default function LoginScreen({ onLoginSuccess }) {
  // --- Login ---
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState(null);

  // --- Recuperar acceso (usuario+correo ? correo con user + password temporal) ---
  const [recOpen, setRecOpen] = useState(false);
  const [recLoading, setRecLoading] = useState(false);
  const [recMsg, setRecMsg] = useState(null);
  const [recUsername, setRecUsername] = useState('');
  const [recEmail, setRecEmail] = useState('');

  // --- Forzar cambio de contrase&ntilde;a en primer login ---
  const [forceOpen, setForceOpen] = useState(false);
  const [forceNewPass, setForceNewPass] = useState('');
  const [forceNewPass2, setForceNewPass2] = useState('');
  const [forceMsg, setForceMsg] = useState(null);
  const [loggedUser, setLoggedUser] = useState(null);

  const API_BASE = 'https://facturas.verdevalle.com.mx';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const res = await axios.post(
        `${API_BASE}/api/login`,
        { username, password, rememberMe },
        { withCredentials: true }
      );

      if (res.data?.success) {
        const u = res.data.user;
        setLoggedUser(u);
        if (u?.mustChangePassword) {
          // Mostrar modal obligatorio de cambio de contrase�a
          setForceOpen(true);
        } else {
          onLoginSuccess(u);
        }
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Error al iniciar sesi&oacute;n');
    }
  };

  // --- Recuperaci�n: abrir/cerrar y enviar ---
  const openRec = () => {
    setRecOpen(true);
    setRecMsg(null);
    setRecUsername(username || '');
    setRecEmail('');
  };
  const closeRec = () => setRecOpen(false);

  const handleRecover = async () => {
    setRecMsg(null);
    if (!recUsername || !recEmail) {
      setRecMsg('Ingresa usuario y correo.');
      return;
    }
    try {
      setRecLoading(true);
      await axios.post(
        `${API_BASE}/api/recover-credentials`,
        { username: recUsername.trim(), email: recEmail.trim() },
        { withCredentials: true }
      );
      setRecMsg('Si los datos existen, te enviamos un correo con tu usuario y una contraseña temporal.');
      setTimeout(() => setRecOpen(false), 1500);
    } catch (err) {
      setRecMsg(
        err.response?.data?.error ||
        'El usuario o el correo no existen. Comun&iacute;cate con Soporte de Verde Valle.'
      );
    } finally {
      setRecLoading(false);
    }
  };

  // --- Forzar cambio de contrase�a ---
  const handleForceChange = async () => {
    setForceMsg(null);
    if (!forceNewPass || !forceNewPass2) {
      setForceMsg('Ingresa y confirma tu nueva contraseña.');
      return;
    }
    if (forceNewPass !== forceNewPass2) {
      setForceMsg('Las contraseñas no coinciden.');
      return;
    }
    try {
      await axios.post(
        `${API_BASE}/api/reset-password`,
        { usuario_id: loggedUser.id, nueva_password: forceNewPass },
        { withCredentials: true }
      );
      setForceMsg('Contraseña actualizada.');
      setTimeout(() => {
        setForceOpen(false);
        onLoginSuccess(loggedUser);
      }, 900);
    } catch (err) {
      setForceMsg(err.response?.data?.error || 'No se pudo actualizar la contraseña.');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        backgroundImage: `url(${fondo})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        flexDirection: 'column'
      }}
    >
      {/* Imagen LOG�STICA 360 */}
      <Box sx={{ mb: 1 }}>
        <img src={cabtop} alt="Log�stica 360" style={{ width: '220px', height: 'auto' }} />
      </Box>

      {/* Caja del login */}
      <Paper
        elevation={6}
        sx={{
          p: 3,
          width: '100%',
          maxWidth: 320,
          borderRadius: 4,
          textAlign: 'center',
          backdropFilter: 'blur(4px)',
          backgroundColor: 'rgba(255, 255, 255, 0.9)'
        }}
      >
        <Box sx={{ mb: 1 }}>
          <img src={cab} alt="Verde Valle" style={{ width: '140px', height: 'auto' }} />
        </Box>

        <Typography variant="subtitle1" align="center" gutterBottom fontWeight={600}>
          Inicio de Sesi&oacute;n
        </Typography>

        <form onSubmit={handleSubmit}>
          <RoundedTextField
            label="Usuario"
            variant="outlined"
            size="small"
            fullWidth
            margin="normal"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              )
            }}
          />

          <RoundedTextField
            label="Contrase&ntilde;a"
            variant="outlined"
            size="small"
            type={showPassword ? 'text' : 'password'}
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" size="small">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
            <GreenCheckbox checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />
            <Typography variant="body2" sx={{ color: '#000', fontWeight: 'bold' }}>
              Recordar sesi&oacute;n
            </Typography>
          </Box>

          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>{error}</Typography>
          )}

          <RoundedButton type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
            INICIAR SESI&Oacute;N
          </RoundedButton>

          {/* Link recuperar */}
          <Box sx={{ mt: 1 }}>
            <Link component="button" type="button" onClick={openRec} underline="hover">
              Recuperar contrase&ntilde;a
            </Link>
          </Box>
        </form>
      </Paper>

      {/* Di�logo: Recuperar acceso */}
      <Dialog open={recOpen} onClose={closeRec} fullWidth maxWidth="xs">
        <DialogTitle>Recuperar acceso</DialogTitle>
        <DialogContent dividers>
          <RoundedTextField
            label="Usuario"
            size="small"
            fullWidth
            margin="dense"
            value={recUsername}
            onChange={(e) => setRecUsername(e.target.value)}
          />
          <RoundedTextField
            label="Correo registrado"
            size="small"
            type="email"
            fullWidth
            margin="dense"
            value={recEmail}
            onChange={(e) => setRecEmail(e.target.value)}
          />
          {recMsg && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {recMsg}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={closeRec} disabled={recLoading}>Cancelar</Button>
          <RoundedButton onClick={handleRecover} disabled={recLoading}>
            {recLoading ? 'Enviando...' : 'Recuperar'}
          </RoundedButton>
        </DialogActions>
      </Dialog>

      {/* Di�logo: Forzar cambio de contrase�a */}
      <Dialog open={forceOpen} onClose={() => {}} fullWidth maxWidth="xs">
        <DialogTitle>Cambiar contrase&ntilde;a</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 1 }}>
            Por seguridad, debes cambiar tu contrase&ntilde;a antes de continuar.
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6}>
              <RoundedTextField
                label="Nueva contrase&ntilde;a"
                size="small"
                type="password"
                fullWidth
                margin="dense"
                value={forceNewPass}
                onChange={(e) => setForceNewPass(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <RoundedTextField
                label="Confirmar contrase&ntilde;a"
                size="small"
                type="password"
                fullWidth
                margin="dense"
                value={forceNewPass2}
                onChange={(e) => setForceNewPass2(e.target.value)}
              />
            </Grid>
          </Grid>
          {forceMsg && (
            <Typography
              variant="body2"
              sx={{ mt: 1 }}
              color={forceMsg.includes('actualizada') ? 'success.main' : 'error'}
            >
              {forceMsg}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <RoundedButton onClick={handleForceChange}>
            Guardar y continuar
          </RoundedButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
